import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import MerchantFacadeApi from "../../services/api/MerchantFacade";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath, getQueryParams, isValNull } from "../../utils";
import FleetCoach from "../../services/api/FleetCoach";

const handleError = (err) => {
  console.log("[handleError] Error in merchant facade actions", err);
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_MERCHANT_FACADE,
    payload,
  };
};

export const setMerchantFacadePicturesList = (payload) => {
  return {
    type: ActionTypes.SET_MERCHANT_FACADE_PIC_LIST,
    payload,
  };
};

export const setCurrentPageMerchantFacade = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_MERCHANT_FACADE,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_MERCHANT_FACADE,
    payload,
  };
};

export const getMerchantFacadePictures =
  (filters, pageRequest) => async (dispatch) => {
    try {
      const finalPayload = {
        ...filters,
        ...pageRequest,
      };
      dispatch(setLoader(true));
      let response = await MerchantFacadeApi.getMerchantFacadePictures(
        getQueryParams(finalPayload)
      );
      if (response) {
        dispatch(setMerchantFacadePicturesList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(
            setCurrentPageMerchantFacade(getPath(pageRequest, "page", 1))
          );
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.LIST_RETRIEVAL_SUCCESS,
          })
        );
      }
      dispatch(setLoader(false));
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const deleteMerchantFacadePictures =
  (merchant_id) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await MerchantFacadeApi.deleteMerchantFacadePictures(
        merchant_id
      );
      if (response) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.DELETION_SUCCESSFULL,
          })
        );
      }
      dispatch(setLoader(false));
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const saveMerchantFacadeEntry = (id, filename, image_tags) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    let payload = {
      s3_filename: filename,
      external_id: id,
      image_tags: image_tags,
    };
    const response = await MerchantFacadeApi.createMerchantFacadeEntry(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getMerchantFacadeImageUploadURL =
  (payload) => async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const response = await MerchantFacadeApi.getPresignedURL(payload);
      dispatch(setLoader(false));
      if (response) {
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
